import React from "react";
import { cn } from "~/utils";

export default React.forwardRef(function ({ className = "", children, ...props }, ref) {
    return (
      <form ref={ref} {...props} className={cn("react", className)}>
        {children}
      </form>
    );
  });